import React from 'react';
import { Search, Package, Filter } from 'lucide-react';

const EmptyMessages = ({
    searchQuery,
    setSearchQuery,
    activeTab,
    receiptPeriodFilter = 'all',
    setReceiptPeriodFilter,
}) => {
    return (
        <div className="p-4 text-center">
            {searchQuery ? (
                <>
                    <div className="w-16 h-16 rounded-full bg-slate-200 flex items-center justify-center mx-auto mb-4">
                        <Search className="w-8 h-8 text-slate-500" />
                    </div>
                    <h3 className="text-lg font-semibold text-slate-900 mb-2">No matching orders</h3>
                    <p className="text-slate-500 text-sm mb-4">No results found for "{searchQuery}"</p>
                    <button
                        onClick={() => setSearchQuery('')}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-semibold hover:bg-blue-700 transition-colors"
                    >
                        Clear Search
                    </button>
                </>
            ) : receiptPeriodFilter !== 'all' && setReceiptPeriodFilter ? (
                <>
                    <div className="w-16 h-16 rounded-full bg-slate-200 flex items-center justify-center mx-auto mb-4">
                        <Filter className="w-8 h-8 text-slate-500" />
                    </div>
                    <h3 className="text-lg font-semibold text-slate-900 mb-2">No orders in this time range</h3>
                    <p className="text-slate-500 text-sm mb-4">
                        Try a different period or show all orders.
                    </p>
                    <button
                        type="button"
                        onClick={() => setReceiptPeriodFilter('all')}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-semibold hover:bg-blue-700 transition-colors"
                    >
                        Show all orders
                    </button>
                </>
            ) : (
                <>
                    <div className="w-16 h-16 rounded-full bg-slate-200 flex items-center justify-center mx-auto mb-4">
                        <Package className="w-8 h-8 text-slate-500" />
                    </div>
                    <h3 className="text-lg font-semibold text-slate-900 mb-2">
                        {activeTab === 'new' ? 'No active orders' : 'No completed orders'}
                    </h3>
                    <p className="text-slate-500 text-sm">
                        {activeTab === 'new'
                            ? 'New orders will appear here when created'
                            : 'Orders will appear here once delivered'}
                    </p>
                </>
            )}
        </div>
    )
}

export default EmptyMessages
